import axios from 'axios';

/**
 * GuayerdOS Frontend API Service
 * 
 * Environment Configuration:
 * - Development: Uses REACT_APP_API_URL or defaults to localhost:8000
 * - Production: Uses REACT_APP_API_URL or defaults to same origin
 * 
 * Security Features:
 * - Automatic token injection via interceptors
 * - Session expiration handling
 * - Error response management
 */

// API Base URL Configuration
// Priority: REACT_APP_API_URL > localhost detection > same origin
const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (window.location.hostname === 'localhost' 
    ? 'http://localhost:8000'
    : window.location.origin);

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add token dynamically
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || '';
    const isAuthEndpoint = url.includes('/auth/login') || 
                          url.includes('/auth/login-with-key') || 
                          url.includes('/auth/verify-token') ||
                          url.includes('/auth/google-login');
    
    if (error.response?.status === 401 && !isAuthEndpoint) {
      // Token expirado o inválido
      const errorMessage = error.response?.data?.detail || '';
      let reason = 'expired';
      
      if (errorMessage.toLowerCase().includes('expired')) {
        reason = 'expired';
      } else if (errorMessage.toLowerCase().includes('invalid')) {
        reason = 'invalid';
      } else if (errorMessage.toLowerCase().includes('inactive')) {
        reason = 'inactivity';
      }
      
      // Disparar evento para que el AuthContext maneje el logout
      window.dispatchEvent(new CustomEvent('sessionExpired', { detail: { reason } }));
    }
    return Promise.reject(error);
  }
);

export default api;
